module.exports = __webpack_public_path__ + "img/registerCertificationUrl.920da1fa.png";